module.exports = __webpack_public_path__ + "img/vw_header.2eb43f0c.jpg";